<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Talsteget
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Steppers används i Degkalkylatorn för heltalsvärden (antal bröd,
      mjölvikt). En minus-knapp till vänster och plus-knapp till höger med
      värdet i mitten.
    </p>

    <PreviewBox label="Live — prova +/−">
      <div>
        <p
          class="font-[Poppins] font-bold text-[10px] text-[#6c7a77] tracking-[0.8px] uppercase mb-1.5"
        >
          Antal bröd
        </p>
        <div
          class="flex items-center rounded-xl overflow-hidden bg-white"
          style="border: 1.5px solid rgba(20, 184, 166, 0.25)"
        >
          <button
            class="w-10 h-11 bg-transparent border-none cursor-pointer text-teal-500 flex items-center justify-center"
            @click="loaves = Math.max(1, loaves - 1)"
          >
            <ChevronDown :size="16" />
          </button>
          <span
            class="flex-1 text-center font-[Plus_Jakarta_Sans] font-bold text-base text-[#191c1e] min-w-[40px]"
            >{{ loaves }}</span
          >
          <button
            class="w-10 h-11 bg-transparent border-none cursor-pointer text-teal-500 flex items-center justify-center"
            @click="loaves = Math.min(20, loaves + 1)"
          >
            <ChevronUp :size="16" />
          </button>
        </div>
      </div>
      <div>
        <p
          class="font-[Poppins] font-bold text-[10px] text-[#6c7a77] tracking-[0.8px] uppercase mb-1.5"
        >
          Mjöl per sats
        </p>
        <div
          class="flex items-center rounded-xl overflow-hidden bg-white"
          style="border: 1.5px solid rgba(20, 184, 166, 0.25)"
        >
          <button
            class="w-10 h-11 bg-transparent border-none cursor-pointer text-teal-500 flex items-center justify-center"
            @click="flour = Math.max(50, flour - 10)"
          >
            <ChevronDown :size="16" />
          </button>
          <span
            class="flex-1 text-center font-[Plus_Jakarta_Sans] font-bold text-base text-[#191c1e] min-w-[60px]"
            >{{ flour }}</span
          >
          <span class="font-[Plus_Jakarta_Sans] text-[13px] text-[#6c7a77] pr-2"
            >g</span
          >
          <button
            class="w-10 h-11 bg-transparent border-none cursor-pointer text-teal-500 flex items-center justify-center"
            @click="flour = Math.min(5000, flour + 10)"
          >
            <ChevronUp :size="16" />
          </button>
        </div>
      </div>
    </PreviewBox>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import { ref } from "vue";
import { ChevronDown, ChevronUp } from "lucide-vue-next";
import PreviewBox from "../components/PreviewBox.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<div class="flex items-center rounded-xl overflow-hidden bg-white" style="border: 1.5px solid rgba(20,184,166,0.25)">
  <button class="w-10 h-11 bg-transparent border-none cursor-pointer text-teal-500 flex items-center justify-center"
    @click="value = Math.max(min, value - step)">
    <ChevronDown :size="16" />
  </button>
  <span class="flex-1 text-center font-[Plus_Jakarta_Sans] font-bold text-base text-[#191c1e]">{{ value }}</span>
  <button class="w-10 h-11 bg-transparent border-none cursor-pointer text-teal-500 flex items-center justify-center"
    @click="value = Math.min(max, value + step)">
    <ChevronUp :size="16" />
  </button>
</div>`;
const cssCode = `/* Container */
display: flex;
border-radius: 12px;                    /* rounded-xl */
overflow: hidden;
border: 1.5px solid rgba(20,184,166,0.25);

/* Värde-text */
font-family: 'Plus Jakarta Sans', sans-serif;
font-weight: 700;
font-size: 16px;                        /* text-base */

/* +/− knappar */
width: 40px;                            /* w-10 */
height: 44px;                           /* h-11 */
color: #14b8a6;                         /* text-teal-500 */`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
const loaves = ref(2);
const flour = ref(500);
</script>
